import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router";
import Form from "../../components/Form";
import FormField from "../../components/FormField";
import Input from "../../components/Input";
import { useAuth } from "../../context/authContext";
import styles from "./Signup.module.css";

const Reset = () => {
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode") ?? undefined;
  const actionCode = searchParams.get("oobCode") ?? undefined;

  return (
    <div>
      <header className={styles.header}>
        <Link to="#" className={styles.logo}>
          only clicks
        </Link>
      </header>
      <div className={styles.container}>
        {(() => {
          switch (mode) {
            case "resetPassword":
              return <ResetPasswordForm oobCode={actionCode ?? ""} />;
            // case "verifyEmail":
            //   return <VerifyEmailMessage />;
            // case "verifyAndChangeEmail":
            //   return <VerifyAndChangeEmailForm />;
            default:
              return <div>Invalid action</div>;
          }
        })()}
      </div>
    </div>
  );
};

interface ResetPasswordFormProps {
  oobCode: string;
}

const ResetPasswordForm = ({ oobCode }: ResetPasswordFormProps) => {
  const auth = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState<string>();
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    auth
      .verifyPasswordResetCode(oobCode)
      .then((email) => setEmail(email))
      .catch(() => setError("Invalid or expired reset link."))
      .finally(() => setLoading(false));
  }, [oobCode]);

  if (loading) return <div>Verifying link…</div>;
  if (error) return <div>{error}</div>;
  if (!email) return null;

  return (
    <>
      <h1 className={styles.title}>Choose a new password</h1>
      <Form<{ newPassword: string; newPasswordConfirm: string }>
        submitText="Reset"
        onSubmit={async ({
          value: { newPassword, newPasswordConfirm },
          formApi,
        }) => {
          if (newPassword !== newPasswordConfirm) {
            formApi.setErrorMap({
              onServer: "Passwords do not match." as never,
            });
            return;
          }

          try {
            await auth.confirmPasswordReset(oobCode, email, newPassword);
            await auth.signIn(email, newPassword);
            navigate("/", { replace: true });
          } catch (err) {
            console.error(err);
            formApi.setErrorMap({
              onServer: "Failed to reset password." as never,
            });
          }
        }}
      >
        {(form) => (
          <div className={styles.formFields}>
            <form.Field name="newPassword">
              {(field) => (
                <FormField label="New password" field={field}>
                  <Input
                    id={field.name}
                    name={field.name}
                    type="password"
                    required={true}
                    value={field.state.value}
                    onBlur={field.handleBlur}
                    onChange={(e) => field.handleChange(e.target.value)}
                  />
                </FormField>
              )}
            </form.Field>
            <form.Field name="newPasswordConfirm">
              {(field) => (
                <FormField label="Confirm new password" field={field}>
                  <Input
                    id={field.name}
                    name={field.name}
                    type="password"
                    required={true}
                    value={field.state.value}
                    onBlur={field.handleBlur}
                    onChange={(e) => field.handleChange(e.target.value)}
                  />
                </FormField>
              )}
            </form.Field>
          </div>
        )}
      </Form>
    </>
  );
};

export default Reset;
